/**
 * JS binding for the `WBMPhotos` native plugin (game-on-freeform U18): save a
 * picture straight to Photos, add-only, with no share sheet.
 *
 * The Swift side is `frontend/ios/App/App/WBMPhotos.swift` (shell lane). Lives in
 * `src/platform/` because that is the only place allowed to import `@capacitor/*`
 * (`__tests__/adapterBoundary.test.ts`).
 *
 * On web, on Android and on any iOS build predating the plugin,
 * `isPhotosSaveAvailable()` is false and the adapter keeps the share sheet.
 */
import { Capacitor, registerPlugin } from "@capacitor/core";

interface WBMPhotosPlugin {
  /** `denied` = refused or restricted. Any other failure rejects. */
  save(opts: { base64: string }): Promise<{ status: "saved" | "denied" }>;
}

const WBMPhotos = registerPlugin<WBMPhotosPlugin>("WBMPhotos");

export function isPhotosSaveAvailable(): boolean {
  try {
    return Capacitor.isPluginAvailable("WBMPhotos");
  } catch {
    return false;
  }
}

export const savePhoto = (base64: string) => WBMPhotos.save({ base64 }).then((r) => r.status);
